import 'babel-polyfill';
import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import { Switch, Route, Redirect, BrowserRouter} from 'react-router-dom';
import Routes from './routes';

import { ValidarTipoSite, CadenaImagenFS_ListKey_GetImage } from './request/rfc';

import Home from './component/home';
import RFC from './component/rfc';
import Transaccion from './component/transaccion';
import Consulta from './component/consulta';
import Login from './component/login';
import Ticket from './component/ticket';
import Global from './component/global';
import Parametro from './component/parametro';
import TicketCredito from './component/ticket/indexCredito';
import Anulacion from './component/anulacion';
import Bitacora from './component/bitacora';

const Loader = () => (
    <div className="lds-ring"><div></div><div></div><div></div><div></div></div> 
);

const WrapperedRoute = ({component: Component, customProps, ...rest}) => <Route {...rest} render={matchProps =>  (<Component {...matchProps} {...customProps} />)} />

class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            logoIzquierda: '',
            isLoading: true,
            isSiteInterno: -1
        };
    }

    componentDidMount() {

        // validar el tipo de site que es, para crear logicas internas
        ValidarTipoSite()
        .then(({ data: ResponseSite }) => {
            const{ Message: MsgSiteAdmin, Data: isSiteInterno } = ResponseSite;
            if(MsgSiteAdmin !== '') {
                alert(MsgSiteAdmin);
            } else {
                CadenaImagenFS_ListKey_GetImage()
                    .then(({ data: Response }) => {
                        const { Message, Data } = Response;
                        if(Message !== '') {
                            alert(Message);
                        } else {
                            let logoIzquierda = '';
                            if(Data != null) {
                                logoIzquierda = `data:image/png;base64,${encodeURIComponent(Data.Imagen)}`;
                            } 
                            this.setState({ logoIzquierda, isLoading: false, isSiteInterno });
                        }
                    })
                    .catch((err) => { console.log(err); });
            }
        })
        .catch((err) => { console.log(err); });

    }

    render() {
        const { baseUrl, logoIzquierda, isLoading, isSiteInterno } = this.state

        if(isLoading) {
            return null;
        }

        if(isSiteInterno == '1') {
            const customProps = { isSiteInterno };
            return (
                <Fragment>
                    <div className="row">
                        <img width="250" height="100" src={logoIzquierda} />
                    </div>
                    <Fragment>
                    <div className="row">
                        <div className="jumbotron jumbotron-background col-12">
                            <h3 className="h3-shadow text-center">Bienvenido al servicio de</h3>
                            <h1 className="h1-shadow text-center">Facturación Electrónica</h1>
                            <hr />
                            <BrowserRouter>
                                <Switch>
                                    <WrapperedRoute exact path={`${baseUrl}${Routes.Login}`} component={Login} customProps={customProps} />
                                    <WrapperedRoute path={`${baseUrl}${Routes.Home}`} component={Home} customProps={customProps} />
                                    <WrapperedRoute path={`${baseUrl}${Routes.RFC}/:tipoFactura`} component={RFC} customProps={customProps} />
                                    <WrapperedRoute path={`${baseUrl}${Routes.Consulta}`} component={Consulta} customProps={customProps} />
                                    <WrapperedRoute path={`${baseUrl}${Routes.Global}`} component={Global} customProps={customProps} />
                                    <WrapperedRoute path={`${baseUrl}${Routes.Parametro}`} component={Parametro} customProps={customProps} />
                                        <WrapperedRoute path={`${baseUrl}${Routes.Ticket}/:cliente/:correo/:usocfdi/:tipoFactura/:versionCFDI`} component={Ticket} customProps={customProps} />
                                        <WrapperedRoute path={`${baseUrl}${Routes.TicketCredito}/:cliente/:correo/:usocfdi/:tipoFactura/:clienteId/:clienteNombre/:versionCFDI`} component={TicketCredito} customProps={customProps} />
                                        <WrapperedRoute path={`${baseUrl}${Routes.Anulacion}`} component={Anulacion} customProps={customProps} />
                                        <WrapperedRoute path={`${baseUrl}${Routes.Bitacora}`} component={Bitacora} customProps={customProps} />
                                    <Redirect to={`${baseUrl}${Routes.Login}`} />
                                </Switch>
                            </BrowserRouter>
                        </div>
                    </div>
                </Fragment>
                </Fragment>
            )
        } else {
            const customProps = { isSiteInterno } ;
            return (
                <Fragment>
                    <div className="row">
                        <img width="250" height="100" src={logoIzquierda} />
                    </div>
                    <div className="row">
                        <div className="jumbotron jumbotron-background col-12">
                            <h3 className="h3-shadow text-center">Bienvenido al servicio de</h3>
                            <h1 className="h1-shadow text-center">Facturación Electrónica</h1>
                            <hr />
                            <BrowserRouter>
                                <Switch>
                                    <WrapperedRoute exact path={`${baseUrl}${Routes.Home}`} component={Home} customProps={customProps} />
                                    <Route path={`${baseUrl}${Routes.RFC}`} component={RFC} />
                                    <Route path={`${baseUrl}${Routes.Consulta}`} component={Consulta} />
                                    <Route path={`${baseUrl}${Routes.Transaccion}/:cliente/:correo/:usocfdi/:versionCFDI`} component={Transaccion} />
                                    <Redirect to={`${baseUrl}${Routes.Home}`} />
                                </Switch>
                            </BrowserRouter>
                        </div>
                    </div>
                </Fragment>
            )
        }
        
    }

}

render(
    <Layout />
    , document.getElementById('root')
);


// WEBPACK FOOTER //
// ./Public/src/js/index.js